import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-07/task-01";

const task: Slide = {
  titleHtml:
    "Knowing the relations between the impedance Z, the sound wave ratio SWR and the<br>reflection coefficient R solve a task.",
  description: "Drag and drop the values at their correct locations in the table.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
